import React from 'react';
import '../styles/WhyChooseReventLabsSection.css';

const WhyChooseReventLabsSection: React.FC = () => {
  // Statistics data
  const stats = [
    { number: "7+", label: "Years Experience" },
    { number: "200+", label: "Successful Projects" },
    { number: "98%", label: "Client Satisfaction" }
  ];

  return (
    <section className="wcb-section">
      <div className="wcb-container">
        <div className="wcb-header">
          <h2 className="wcb-title">Why Choose ReventLabs</h2>
        </div>
        
        <div className="wcb-content">
          {/* Main grid */}
          <div className="wcb-grid">
            {/* Stats area - spans 3 cells, includes decoration */}
            <div className="wcb-stats-area">
              <div className="wcb-decoration">
                <img src="/assets/half-circle-with-lines.svg" alt="" className="wcb-decoration-svg" />
              </div>
              <div className="wcb-stats-row">
                {stats.map((stat, index) => (
                  <div className="wcb-stat-item" key={index}>
                    <div className="wcb-stat-number">{stat.number}</div>
                    <div className="wcb-stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Expert Team */}
            <div className="wcb-grid-item wcb-expert-team">
              <img src="/assets/expert-team.svg" alt="Expert Team" className="wcb-feature-image" />
              <div className="wcb-grid-overlay">
                <h3 className="wcb-grid-title">Expert Team</h3>
              </div>
            </div>
            
            {/* Client Success */}
            <div className="wcb-grid-item wcb-client-success">
              <img src="/assets/client-success.svg" alt="Client Success" className="wcb-feature-image" />
              <div className="wcb-grid-overlay">
                <h3 className="wcb-grid-title">Client Success</h3>
              </div>
            </div>
            
            {/* Security Focus */}
            <div className="wcb-grid-item wcb-security-focus">
              <img src="/assets/security-focus.svg" alt="Security Focus" className="wcb-feature-image" />
              <div className="wcb-grid-overlay">
                <h3 className="wcb-grid-title">Security Focus</h3>
              </div>
              <div className="wcb-circle-decoration">
                <img src="/assets/left-circle.svg" alt="" className="wcb-circle-svg" />
              </div>
            </div>
            
            {/* Innovation */}
            <div className="wcb-grid-item wcb-innovation">
              <img src="/assets/innovation.svg" alt="Innovation" className="wcb-feature-image" />
              <div className="wcb-grid-overlay">
                <h3 className="wcb-grid-title">Innovation</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseReventLabsSection; 
